// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"assignProjectSearch_wrapper__Hh0TH"};